<nb-card style="height: 100%">
  <nb-card-header>
    <h5 i18n>Clean Score</h5>
  </nb-card-header>
  <nb-card-body>
    <div i18n>Select a Robot:</div>
    <div class="mt-2" style="width: 500px">
      <input
        nbInput
        type="text"
        placeholder="Search and select..."
        i18n-placeholder
        [value]="selectedRobot"
        (input)="filterRobots($event)"
        [nbAutocomplete]="auto"
        fullWidth
      />
      <nb-autocomplete #auto (selectedChange)="onSelect($event)">
        <nb-option *ngFor="let robot of filteredRobots" [value]="robot">
          {{ robot.label }}
        </nb-option>
      </nb-autocomplete>
    </div>
    <div *ngIf="selectedRobot" class="mt-5">
      <app-spinner *ngIf="!smartCleanRecords"></app-spinner>
      <div *ngIf="smartCleanRecords">
        <h6 i18n>Robot: {{ selectedLabel.split(' (')[1].slice(0, -1) }}</h6>
        <hr />
        <div class="d-flex flex-wrap">
          <nb-card *ngFor="let map of maps | keyvalue: reverseOrder" class="mb-3 mr-3" style="max-width: 500px">
            <nb-card-header>Map: {{ map.key }}</nb-card-header>
            <nb-card-body>
              <table class="table table-sm mb-0">
                <thead>
                  <tr>
                    <th class="field-label" i18n>Region ID</th>
                    <th class="field-label" i18n>Region Name</th>
                    <th class="field-label" i18n>Region Type</th>
                    <th class="field-label" i18n>Region Score</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of map.value; let i = index">
                    <td>{{ row.pk.split('#rid#')[1] }}</td>
                    <td *ngFor="let column of ['name', 'region_type']">{{ row[column] }}</td>
                    <td>
                      <input
                        nbInput
                        fieldSize="small"
                        type="number"
                        min="0"
                        max="1"
                        step="0.1"
                        [value]="row.region_score"
                        [(ngModel)]="maps[map.key][i].region_score"
                        (change)="markChanged(row.pk)"
                        style="width: 100px"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </nb-card-body>
          </nb-card>
        </div>
        <button
          class="mt-5"
          nbButton
          status="success"
          (click)="save()"
          [disabled]="!selectedRobot || changed.size === 0 || saving"
          [nbSpinner]="saving"
          nbSpinnerStatus="info"
          i18n
        >
          Save
        </button>
      </div>
    </div>
  </nb-card-body>
</nb-card>
